import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface DownloadStatusContextType {
  hasNewDownload: boolean;
  setHasNewDownload: Dispatch<SetStateAction<boolean>>;
}

const DownloadStatusContext = createContext<DownloadStatusContextType | null>(
  null
);

interface DownloadStatusProviderProps {
  children: ReactNode;
}

export const DownloadStatusProvider = ({
  children,
}: DownloadStatusProviderProps) => {
  const [hasNewDownload, setHasNewDownload] = useState(false);

  return (
    <DownloadStatusContext.Provider
      value={{ hasNewDownload, setHasNewDownload }}
    >
      {children}
    </DownloadStatusContext.Provider>
  );
};

export const useDownloadStatus = (): DownloadStatusContextType => {
  const context = useContext(DownloadStatusContext);
  if (!context) {
    throw new Error(
      "useDownloadStatus must be used within a DownloadStatusProvider"
    );
  }
  return context;
};
